import { FastlyImage } from '@components/common/image'

type Props = {
  handleBecomeTeacher: () => void
  earnings: string
}

const FirstFold = ({ earnings, handleBecomeTeacher }: Props) => {
  return (
    <div className="overflow-hidden md:rounded-b-2xl hero-gradient-red-purple">
      <div className="flex flex-col md:flex-row  container mx-auto">
        <div className="flex flex-col justify-center px-5 md:px-0 md:pl-5">
          <h1 className="text-4xl md:text-6xl text-center md:text-left text-white font-700 pt-12 pb-4 leading-10">
            Teach kids to code
          </h1>
          <p className="text-xl text-white text-center md:text-left font-400 pb-8">
            Earn {earnings} every month from home and empower the creators of
            the future
          </p>
          <div className="w-full md:w-auto flex justify-center md:justify-start">
            <button
              onClick={handleBecomeTeacher}
              className="ml-2 inline-block text-2xl md:text-lg w-full md:w-auto font-600 btn btn-orange align-middle text-white font-medium py-3 md:py-2 rounded focus:outline-none"
            >
              Become a teacher
            </button>
          </div>
        </div>
        <FastlyImage
          src="/images/teacher-lp/firstFold/hero.png"
          alt="teacher hero"
          height="550"
          width="800"
        />
      </div>
    </div>
  )
}

export default FirstFold
